import { css } from '@emotion/core';
import { Css } from '../../../../ui';
import { Color } from '../../../../styles/Color';

export const columnHeaderStyles = css`
	font-weight: 300;
	font-size: ${Css.pxToRem(14)};
	line-height: ${Css.pxToRem(19)};
	padding-bottom: ${Css.pxToRem(8)};
	color: ${Color.Neutral6};
`;
